/*
 * @Descripttion:
 * @Author: etong
 * @Date: 2022-02-21 13:42:09
 * @LastEditors: liujiang liujiang@shjinjia.com.cn
 * @LastEditTime: 2023-05-30 15:51:11
 */
const map = {
  // 工具箱
  logisticsCharges: () => import('@/views/toolBox/LogisticsCharges'), // 物流资费查询
  generalQueryList: () => import('@/views/toolBox/GeneralQueryList'), // 通用查询列表
  generalQuery: () => import('@/views/toolBox/GeneralQuery'), // 通用查询
  generalFileUpload: () => import('@/views/toolBox/GeneralFileUpload'), // 通用文件上传
  generalFileTemConf: () =>
    import('@/views/toolBox/GeneralFileUpload/GeneralFileTemConf'), // 通用文件上传
  generalFileUploadDetail: () =>
    import('@/views/toolBox/GeneralFileUpload/GeneralFileUploadDetail'), // 通用文件上传
  billUploadRuleList: () => import('@/views/toolBox/BillUploadRuleList'), // 账单模板配置
  billUploadRuleDetail: () => import('@/views/toolBox/components/BillUploadRuleDetail'), // 模板配置明细
  generalFileRoleConf: () =>
    import('@/views/toolBox/GeneralFileUpload/GeneralFileRoleConf'), // 通用文件上传角色配置
  generalUploadMapDetail: () =>
    import('@/views/toolBox/GeneralUploadMapDetail'), // 数据配置详情
  creatGeneralUploadMap: () =>
    import('@/views/toolBox/GeneralUploadMapDetail'), // 数据配置详情
  addressParser: () =>
    import('@/views/toolBox/AddressParser'), //  收货地址智能解析
  detail: () =>
    import('@/views/toolBox/AddressParser/Detail'), //  收货地址智能解析明细
  alipayBillArchiveStatistic: () =>
    import('@/views/toolBox/AlipayBillArchiveStatistic'), //  支付宝账单归档统计
  generateEmail: () =>
    import('@/views/toolBox/GenerateEmail') //  生成邮件
}

export default map
